$(document).ready(function () {
  $(".hero_slider .inner").slick({
    dots: $(".hero_slider .inner").children().length > 1,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    fade: true,
    arrows: true,
    cssEase: "ease-in-out",
    adaptiveHeight: true,
    prevArrow: `<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>`,
    nextArrow: `<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>`,
  });
  $(".image_with_content .inner").slick({
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    fade: true,
    arrows: true,
    adaptiveHeight: true,
    prevArrow: `<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>`,
    nextArrow: `<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>`,
  });
  jQuery(function () {
    jQuery(".aspot-tile").click(function () {
      var $tile = $(this);
      if (!$tile.hasClass("expanded")) {
        $tile.addClass("expanded");

        // Add tracking for tiles
        /*
      var title = $tile.find('.tile-title').text();
      console.log(title);
      ga('send', {
        hitType: 'event',
        eventCategory: 'Owners Corner',
        eventAction: 'Click a tile',
        eventLabel: title
      });
      //*/
      }

      var title = $tile.find(".tile-title").text();
      console.log(title);
    });
    jQuery(".tile-arrow-back").click(function (event) {
      event.stopPropagation();
      var $tile = $(this.parentElement);
      if ($tile.hasClass("expanded")) {
        $tile.removeClass("expanded");
      }
    });

    // Track PDF downloads
    jQuery('.aspot-tile a[href*=".pdf?v="]').click(function () {
      console.log(this.text);
      ga("send", {
        hitType: "event",
        eventCategory: "Owners Corner",
        eventAction: "PDF download",
        eventLabel: this.text,
      });
    });

    // Track CTA clicks
    jQuery(".aspot-tile a.button").click(function () {
      console.log(this.text);
      ga("send", {
        hitType: "event",
        eventCategory: "Owners Corner",
        eventAction: "CTA click",
        eventLabel: this.text,
      });
    });
  });
  $(".similar_select").change(function () {
    var val1 = $("#Resource_Topic").val();
    var val3 = $("#owner").val();
    $(".custom_class_h").each(function () {
      var value = $(this).find(".values_hai").text();
      var n = value.includes(val1);
      var n2 = value.includes(val3);

      if (n && n2) {
        $(this).show();
        $(".sorry_message").hide();
      } else {
        $(this).hide();
      }
      if ($(".custom_class_h:visible").length < 1) {
        console.log($(".custom_class_h:visible").length);
        $(".sorry_message").show();
      }
    });
  });

  $(".product__accordion.js-update-to-html").each(function () {
    let $this = $(this);
    $this
      .find(".accordion__content")
      .html($this.find(".accordion__content").text());
  });

  //tabs js start//
  $(".image-content.video-custom").each(function () {
    if ($(this).find("video").length > 0) {
      $(this).addClass("video-tag");
    } else {
      $(this).removeClass("video-tag");
    }
  });

  $(".inner-coll").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    speed: 300,
    dots: true,
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: false,
  });
  $(".inner-coll1").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    speed: 300,
    dots: true,
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: false,
  });
  $(".coll-title:first").addClass("coll-active");
  $(".inner-coll:first").addClass("content-active");
  $(".coll-title").click(function () {
    $(".coll-title").removeClass("coll-active");
    $(this).addClass("coll-active");
    var coll_attr1 = $(this).attr("coll-attr");
    //alert(coll_attr1);

    $(".inner-coll").each(function () {
      var coll_attr2 = $(this).attr("coll-content");
      if (coll_attr1 == coll_attr2) {
        $(".inner-coll").removeClass("content-active").hide();
        $(this).addClass("content-active").show();
        $(".inner-coll").slick("refresh");
      }
    });
  });
  //tabs jquery end//

});
